import {getSelectedVendorFromStorage} from 'utils/Helper';

export const getCouponVendorId = (): string => {
  const vendorId = getSelectedVendorFromStorage()?.id;

  return typeof vendorId === 'string' || typeof vendorId === 'number' ? String(vendorId) : '0';
};
